module.exports = __webpack_public_path__ + "static/media/cc-mastercard.73bb0b54.svg";